import DeliveryFoodModeUtils from "../services/DeliveryFoodModeUtils";
import DeliveryFoodUtils from "../services/DeliveryFoodUtils";
import { DeliveryFoodModeRootData } from "../types/DeliveryFoodModeTypes";
import { DeliveryFoodIngredient } from "../types/DeliveryFoodTypes";
import DeliveryFoodMode from "./DeliveryFoodMode";

export class DeliveryFoodPrepForDeliveryTimeMode extends DeliveryFoodMode {
    getToolbarInfo(state: any) {
        // in the case of prepForDeliveryTime extract the sum of all times for commissary, using context state
        const prepForDeliveryTimeTotal = state?.ingredients
            ?.map((ingredient: DeliveryFoodIngredient) => {
                return ingredient.results.COM?.prepForDeliveryTime.total || 0;
            })
            .reduce((a: any, c: any) => a + c, 0);

        const totalTimeDisplay = DeliveryFoodUtils.getHoursDisplay(prepForDeliveryTimeTotal);

        return <div>Total: {totalTimeDisplay}</div>;
    }

    ingredientsFilter(mode: DeliveryFoodMode, ingredient: DeliveryFoodIngredient, index: number) {
        const { dataForDelivery, results } = ingredient;

        if (!dataForDelivery || !results) {
            return false;
        }

        const hasPrepForDeliveryValues = (ingredient.results.COM?.prepForDelivery.total || 0) > 0;

        if (hasPrepForDeliveryValues) {
            console.info(`Selected ${ingredient.data.name} for prep!`);
        }

        return hasPrepForDeliveryValues;
    }

    constructor(rootData: DeliveryFoodModeRootData) {
        super(rootData);
        this.label = "Prep for Delivery Times";
        const { restaurants } = rootData;

        this.display = DeliveryFoodModeUtils.buildPrepForDeliveryModeDisplay(restaurants);
    }
}
